module.exports = __webpack_public_path__ + "img/driver.78b0704c.png";